module.exports = __webpack_public_path__ + "img/hm2.5fee4b07.png";